import { render, staticRenderFns } from "./google.vue?vue&type=template&id=5f569e20&scoped=true&"
import script from "./google.vue?vue&type=script&lang=js&"
export * from "./google.vue?vue&type=script&lang=js&"
import style0 from "./google.vue?vue&type=style&index=0&id=5f569e20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f569e20",
  null
  
)

export default component.exports